import React, { lazy } from 'react';
import styled from 'styled-components';

import { Close as CloseIcon } from '@mui/icons-material';
import { Chip as MuiChip, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

const TagChip = ({ handleDelete, isCanDelete, tag, iconColor }) => {
  const { t } = useTranslation();
  // need to refactor this component, get rid of incoherence in format like value/value.value/value.title etc

  const label = tag?.title || tag?.value || tag;

  const theme = useTheme()
  return (
    <SMuiChip
      label={typeof label === 'string' ? t(label) : label}
      deleteIcon={
        isCanDelete ? (
          <CloseIcon
            style={{
              width: '18px',
              color: iconColor ? iconColor : theme.palette.colors.black100,
            }}
          />
        ) : (
          false
        )
      }
      onDelete={isCanDelete ? () => handleDelete(tag) : false}
    />
  );
};

const SMuiChip = styled(MuiChip)`
  background: ${({theme}) => theme.palette.colors.blue200} !important;
  height: 35px;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: ${({theme}) => theme.palette.colors.black100};
  padding: 0 5px;
  margin: 5px 0 !important;
  &:not(:last-child) {
    margin-right: 10px !important;
  }
`;

export default TagChip;
